<template>
  <div class="app" @keydown.space.prevent="togglePlaying">
    <header class="app__header header">
      <!-- <h1 class="header__heading">Das FE-Hörbuch</h1>
      <p class="header__description">
        Als Erinnerung an deine Zeit bei 3pc, insbesondere an dein Frontend Team
      </p> -->
      <img class="header__image" src="/background.png" alt="" />

      <!-- <div>
        <img style="max-height: 60vh" src="/logo.png" alt="" />
      </div> -->
      <!-- <p class="header__description">ein kleines</p>
      <h1 class="header__heading">Hörbuch</h1> -->
      <!-- <p class="header__description">
        für dich Jessi, von deinen Kolleg:innen bei 3pc
      </p> -->
    </header>
    <main class="app__main main">
      <!-- {{ seeking }}

      {{ waiting }}

      {{ ended }}

      {{ stalled }} -->
      <ul class="main__chapter-list chapter-list">
        <li
          class="chapter-list__item"
          :class="{ 'chapter-list__item--active': currentChapter === index }"
          v-for="(chapter, index) in CHAPTER_LIST"
          :key="chapter.file"
        >
          <button
            class="chapter-list__button"
            type="button"
            @click="switchTrack(index)"
          >
            <span>Track {{ index + 1 }} - </span>
            <span>
              {{ chapter.name }}
            </span>
          </button>
        </li>
      </ul>
      <audio ref="audioElement" />

      <div class="main__audio-player audio-player">
        <button
          class="audio-player__button"
          @click="togglePlaying"
          type="button"
        >
          <span v-if="playing">⏸︎</span>
          <span v-else>⏵︎</span>
        </button>
        <div class="audio-player__progress progress-bar" @click="onClick">
          <div
            class="progress-bar__filled"
            :style="{ width: `${(currentTime / duration) * 100}%` }"
          >
            <!-- <span class="progress-bar__time"
              >{{ currentTime | formatTime }}
              {{ currentTime / duration }}
            </span> -->
          </div>
          <span class="progress-bar__time">
            <span>
              {{ formattedCurrentTime }}
            </span>
            <span>
              {{ formattedDuration }}
            </span>
          </span>
        </div>
      </div>
    </main>
  </div>
</template>

<script lang="ts" setup>
import { Temporal } from "@js-temporal/polyfill";
import { useMediaControls, whenever } from "@vueuse/core";
import { ref, useTemplateRef, computed, watch, onMounted, nextTick } from "vue";

const CHAPTER_LIST = [
  {
    name: "Intro",
    file: "intro",
  },
  { name: "Der Hase und das Brot", file: "ronny - der hase und das brot" },
  {
    name: "Panik im Paradies",
    file: "martin - kids panik im paradies",
  },
  {
    name: "How to: Pflege einer besonderen Pflanze",
    file: "bakty - anleitung zur pflege einer besonderen pflanze",
  },
  {
    name: "Einfache Radieschensuppe in 19 Schritten",
    file: "jenny - einfache radieschensuppe in 19 schritten",
  },

  { name: "Zwischenspiel", file: "zwischenspiel" },
  {
    name: "Eddie, sie alter Wuselknoedel",
    file: "melanie - eddie, sie alter wuselknoedel",
  },
  { name: "Bruder Innerlich", file: "manuel - bruder innerlich" },
  {
    name: "Zwischenspiel",
    file: "zwischenspiel 2",
  },
  {
    name: "Die Jagd nach dem Schnatz",
    file: "jenny - die jagd nach dem schnatz",
  },
  {
    name: "The Adventure Never Ends",
    file: "sae - the adventure never ends",
  },
  {
    name: "Outro",
    file: "outro",
  },
];

const currentChapter = ref(0);

const audioElement = useTemplateRef<HTMLAudioElement>("audioElement");

const currentSrc = computed(() => {
  return `./chapters/${CHAPTER_LIST[currentChapter.value].file}.mp3`;
});

const playing = ref(false);
const duration = ref(0);
const currentTime = ref(0);
const ended = ref(false);

const switchTrack = (index: number) => {
  currentChapter.value = index;
  playing.value = false;
  audioElement.value.pause();
  audioElement.value.currentTime = 0;
  currentTime.value = 0;

  nextTick(() => {
    playing.value = true;
    audioElement.value.play();
  });
};

watch(ended, (ended) => {
  if (!ended) return;
  const nextChapter = currentChapter.value + 1;
  if (nextChapter >= CHAPTER_LIST.length) {
    playing.value = false;
    return;
  }

  switchTrack(nextChapter);
});

const togglePlaying = () => {
  playing.value = !playing.value;
  audioElement.value[playing.value ? "play" : "pause"]();
};

const onClick = (event: MouseEvent) => {
  const progressBar = event.currentTarget as HTMLDivElement;
  const clickPosition = event.offsetX;
  const totalWidth = progressBar.clientWidth;
  const newTime = (clickPosition / totalWidth) * duration.value;

  audioElement.value.currentTime = newTime;
};

const formattedCurrentTime = computed(() => {
  return `${Math.floor(currentTime.value / 60)
    .toString()
    .padStart(2, "0")}:${(Math.floor(currentTime.value) % 60)
    .toString()
    .padStart(2, "0")}`;
});

const formattedDuration = computed(() => {
  return `${Math.floor(duration.value / 60)
    .toString()
    .padStart(2, "0")}:${(Math.floor(duration.value) % 60)
    .toString()
    .padStart(2, "0")}`;
});

onMounted(() => {
  audioElement.value.addEventListener("timeupdate", () => {
    ended.value = false;
    currentTime.value = audioElement.value.currentTime;
  });
  audioElement.value.addEventListener("durationchange", () => {
    duration.value = audioElement.value.duration;
  });
  audioElement.value.addEventListener("ended", () => {
    ended.value = true;
  });
  audioElement.value.addEventListener("play", () => {
    ended.value = false;
  });

  watch(
    currentSrc,
    (src) => {
      if (audioElement.value.src !== src) {
        audioElement.value.src = src;
        audioElement.value.load();
      }
    },
    { immediate: true }
  );
});
</script>

<style>
.app {
  min-height: 100vh;
  display: flex;
  position: relative;
  flex-direction: column;
}

.app__header {
  position: sticky;
  /* display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column; */
  top: 0;
  color: var(--color-yellow);
  font-weight: 800;
  background-color: var(--color-black);
  background-image: radial-gradient(
    circle at bottom,
    var(--color-yellow),
    var(--color-white),
    var(--color-red),
    var(--color-green),
    var(--color-gray),
    var(--color-black)
  );
  /* padding: 1rem; */
  /* padding-block-end: 4rem;
  padding-block-start: 2rem; */
  /* height: 100vh; */
}

.header__image {
  width: 100%;
}

.header__heading {
  font-size: var(--step-8);
  line-height: 1;
  margin: 0;
  font-weight: 800;
  text-align: center;
  /* font-family: Georgia, "Times New Roman", Times, serif; */
}

.header__description {
  margin: 0;
  text-align: center;
  font-family: Georgia, "Times New Roman", Times, serif;
  font-size: var(--step-0);
  max-width: 50rem;
}

.app__main {
  flex-grow: 1;
  justify-content: flex-end;
  display: flex;
  flex-direction: column;
  position: relative;
}

.chapter-list {
  width: 100%;
  list-style-type: none;
  padding-inline-start: 0;
  display: flex;
  flex-direction: column;
  margin-block: 0;
  overflow: hidden;
  box-shadow: 0 0 0.2rem var(--color-gray);
}
.chapter-list__item {
  background-color: var(--color-green);
  display: flex;
  flex-direction: column;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
}
/* 
.chapter-list__item:where(:nth-child(3n + 1)) {
  background-color: var(--color-red);
}
*/
.chapter-list__item:where(:nth-child(2n)) {
  background-color: var(--color-gray);
}

.chapter-list__item--active {
  color: var(--color-yellow);
}

.chapter-list__button {
  cursor: pointer;
  text-align: left;
  font-size: var(--step-3);
  font-weight: 800;
  text-overflow: ellipsis;
  overflow: hidden;
  border: 0;
  transition: transform 0.2s;
}
.chapter-list__button:focus-visible {
  outline: 0.25rem solid var(--color-focus);
  outline-offset: -0.25rem;
  transform: scale(1) !important;
}

@media (hover: hover) {
  .chapter-list__button:hover {
    transform: scale(1.01);
  }

  .chapter-list__button:hover:focus:active {
    transform: scale(0.975);
  }
}

.main__audio-player {
  position: sticky;
  bottom: 0;
}

.audio-player {
  box-shadow: 0 0 0.2rem var(--color-gray);
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  background-color: var(--color-black);
  font-size: var(--step-4);
  padding: 1rem;
}
.audio-player__button {
  border: 0;
  background-color: var(--color-yellow);
  border-radius: 10px;
  height: 1em;
  width: 1em;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-black);
  transition: transform 0.2s;
  cursor: pointer;
  font-family: inherit;
}

.audio-player__button span {
  line-height: 1;
}

.audio-player__button:focus-visible {
  outline: 0.25rem solid var(--color-focus);
  outline-offset: -0.25rem;
}

@media (hover: hover) {
  .audio-player__button:hover {
    transform: scale(1.1);
  }
  .audio-player__button:hover:focus:active {
    transform: scale(0.95);
  }
}

.audio-player__progress {
  width: 100%;
}

.progress-bar {
  width: 100%;
  height: 1em;
  background-color: var(--color-gray);
  color: var(--color-black);
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  line-height: 1;
}

.progress-bar__filled {
  height: 100%;
  z-index: 0;
  position: relative;
  background-color: var(--color-white);
}

.progress-bar__time {
  box-shadow: inset 0 0 0.2rem var(--color-black);
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: transparent;
  font-size: var(--step-2);
  color: var(--color-green);
  font-weight: 900;
  padding-inline: 0.75rem;
  pointer-events: none;
}
</style>
